/**
 * @file        src/api/actionCenter.js
 * @description Action Centre API calls (/api/action-center) — the console's
 *              open work, DERIVED from the twelve queues that already exist
 *              rather than stored in a task table of its own.
 *
 *              `audience` is the SCREEN's, never a picker: the two dashboards
 *              each pass their own, and the Action Centre page passes none —
 *              which is what "whole business" means here. There is no 'all'
 *              value to send (§9d).
 * @author      Kinetika Labs
 * @created     2026-09-24
 * @changelog
 *   - 2026-09-24 Claude — Initial.
 */
import { get, post } from './client';

/** Per-queue counts for the Dashboard panel. params: { audience? }. */
export const actionCenterOverview = (params) => get('/action-center/overview', { params });

/**
 * One page of open work.
 * params: { audience?, kind?, owner?, customerType?, brand?, search?, from?, to?,
 *           page, pageSize }.
 * Response: { data: { rows, total, page, pageSize, queues } } — `queues` carries
 * the same counts the panel reads, from the same query, so a chip can never
 * advertise a number the table cannot show.
 */
export const listActionItems = (params) => get('/action-center/items', { params });

/**
 * Close one item. Only the queues whose "done" is ONE unambiguous step accept
 * this (an enquiry, a reconciliation item); the rest answer 409 with
 * NEEDS_DECISION or AWAITING_SUPPLIER, because a corporate approval creates a
 * login and a cancellation is the supplier's to settle. The item's own record is
 * what changes — there is no flag on this screen to set.
 */
export const resolveActionItem = (kind, id, body) =>
  post(`/action-center/items/${kind}/${id}/done`, body || {});
